import { InternalAxiosRequestConfig } from 'axios'
import lodash from 'lodash'
import $global from '@xt/client/store/global'
import { getXTDevId } from '@xt/client/utils/uuid'
import { getFp } from '@xt/client/utils/fingerprint/report'

export const clientInfoInterceptors = {
  success: async (options: InternalAxiosRequestConfig) => {
    await initDevId()
    const header = lodash.assign({}, clientInfoHeader, options.headers)

    // 处理公共请求头
    const baseHeaders: string[] = []
    Object.keys(header).forEach(key => {
      if (key.startsWith('x-')) {
        // filter [null, undefined, '']
        if (!lodash.isNil(header[key]) && header[key] !== '') {
          baseHeaders.push(`${key.slice(2)}=${header[key]}`)
        }

        delete header[key]
      }
    })

    options.headers = {
      ...header,
      'x-xt-client-info': baseHeaders.join(';')
    } as any

    return options
  },
  fail: () => {}
}

let clientInfoHeader = {
  'x-version': $global.version,
  'x-appid': $global.xtAppid
}

export function initClientHeader(header: Record<string, any>) {
  clientInfoHeader = { ...clientInfoHeader, ...header }
  return clientInfoHeader
}

/** 初始化设备ID */
export async function initDevId(forceRefreshDevId = false) {
  if (!$global.devId || forceRefreshDevId) {
    $global.devId = getXTDevId($global.platform)
    console.log('改变了devId', $global.devId)
  }
  if (!$global.xtDevId) {
    const { current } = await getFp($global)
    $global.xtDevId = current
    console.log('改变了xtDevId', $global.xtDevId)
  }
  initClientHeader({ 'x-devId': $global.devId, 'x-xtDevId': $global.xtDevId })
}
